import { OktaAuth, TokenManager } from "@okta/okta-auth-js";
import { setAuthState, showNotifier } from "../store/globalSlice";
import config from "../config";
import store from "../store";

const CLIENT_ID = config.oktaClientId;
const ISSUER = `${config.oktaIssuer}`;
const OKTA_TESTING_DISABLEHTTPSCHECK =
  process.env.OKTA_TESTING_DISABLEHTTPSCHECK || false;
const BASENAME = process.env.PUBLIC_URL || "";
const REDIRECT_URI = `${window.location.origin}${BASENAME}/login/callback`;

const oidcConfig = {
  clientId: CLIENT_ID,
  issuer: ISSUER,
  redirectUri: REDIRECT_URI,
  scopes: ["openid", "profile", "email", "groups"],
  pkce: true,
  disableHttpsCheck: OKTA_TESTING_DISABLEHTTPSCHECK,
  tokenManager: {
    autoRenew: true,
    expireEarlySeconds: 5 * 60, // expire 5 min early
  },
};

const oktaAuth = new OktaAuth(oidcConfig);
export const tokenManager = new TokenManager(oktaAuth);

tokenManager.on("renewed", async function oktaTokenRenewed() {
  try {
    const tokens = JSON.parse(
      tokenManager?.storage?.storageProvider["okta-token-storage"]
    );
    store.dispatch(
      setAuthState({
        isAuthenticated: true,
        id_token: tokens?.idToken?.idToken,
        access_token: tokens?.accessToken?.accessToken,
      })
    );
  } catch {
    store.dispatch(
      showNotifier({
        message: "Something went wrong. Please try again.",
        severity: "error",
      })
    );
  }
});

export default oktaAuth;
